import BeneficiaryDetails from 'modules/beneficiaries/components/BeneficiaryDetails';

function BeneficiaryDetailsPage() {
  return <BeneficiaryDetails />;
}

export default BeneficiaryDetailsPage;
